 
import {  TiposDeDados } from "@/core/config/PerfisConfig";

class Endereco { 
   


    public static campos = () => {
        return [ 
            // {
            //     nome: "cep",
            //     type: "text",
            //     label: "CEP",
            //     sm: 6 ,
            //     lg: 6, 
            //     disabled: false
            // }, 
            {
                nome: "uf",
                type: "select",
                label: "Estado",
                sm: 6 ,
                lg: 6, 
                disabled: false,
                options: TiposDeDados.estado() 
            }, 
            {
                nome: "cidade",
                type: "text",
                label: "Cidade",
                sm: 6 ,
                lg: 6, 
                disabled: false
            },  
            {
                nome: "bairro",
                type: "text",
                label: "Bairro",
                sm: 6 ,
                lg: 6, 
                disabled: false
            },  
            {
                nome: "logradouro",
                type: "text",
                label: "Rua",
                sm: 6 ,
                lg: 6, 
                disabled: false
            },  
            {
                nome: "complemento",
                type: "text",
                label: "Complemento",
                sm: 6 ,
                lg: 6, 
                disabled: false
            },  
            {
                nome: "numero",
                type: "text",
                label: "Número",
                sm: 6 ,
                lg: 6, 
                disabled: false
            }, 
            {
                nome: "observacao",
                type: "text",
                label: "Observação",
                sm: 12 ,
                lg: 12, 
                disabled: false
            }, 
            
        ];
    }  
  
}
 


export   {   Endereco };
